import React from "react";
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  Typography,
  Box,
  Alert,
  AlertTitle,
} from "@material-ui/core";
import WarningIcon from "@material-ui/icons/Warning";
import PropTypes from "prop-types";

const ModalAdvertenciaCopiaClave = ({ open, onClose, onConfirm }) => {
  return (
    <Dialog open={open} onClose={onClose} maxWidth="sm" fullWidth>
      <DialogTitle>
        <Box display="flex" alignItems="center" gap={1}>
          <WarningIcon color="secondary" />
          <Typography variant="h6">Advertencia de Seguridad</Typography>
        </Box>
      </DialogTitle>

      <DialogContent>
        <Alert severity="warning" style={{ marginBottom: 16 }}>
          <AlertTitle>Información Sensible</AlertTitle>
          Estás a punto de copiar una contraseña al portapapeles.
        </Alert>

        <Typography variant="body2" paragraph>
          Por tu seguridad y la de la empresa, ten en cuenta lo siguiente:
        </Typography>

        <Box component="ul" style={{ paddingLeft: 24, margin: 0 }}>
          <Typography component="li" variant="body2" gutterBottom>
            ❌ <strong>No pegues</strong> la contraseña en lugares inseguros
            (chats, emails, notas sin encriptar)
          </Typography>
          <Typography component="li" variant="body2" gutterBottom>
            ⏱️ El portapapeles se <strong>limpiará automáticamente</strong> en
            45 segundos
          </Typography>
          <Typography component="li" variant="body2" gutterBottom>
            📋 Esta acción quedará <strong>registrada</strong> en el sistema de
            auditoría
          </Typography>
          <Typography component="li" variant="body2" gutterBottom>
            ⚖️ El mal uso puede tener <strong>consecuencias</strong> según
            políticas de la empresa
          </Typography>
        </Box>

        <Alert severity="info" style={{ marginTop: 16 }}>
          Este mensaje solo se mostrará una vez por sesión.
        </Alert>
      </DialogContent>

      <DialogActions>
        <Button onClick={onClose}>Cancelar</Button>
        <Button
          onClick={onConfirm}
          variant="contained"
          color="primary"
          autoFocus
        >
          Entiendo, Continuar
        </Button>
      </DialogActions>
    </Dialog>
  );
};

ModalAdvertenciaCopiaClave.propTypes = {
  open: PropTypes.bool.isRequired,
  onClose: PropTypes.func.isRequired,
  onConfirm: PropTypes.func.isRequired,
};

export default ModalAdvertenciaCopiaClave;
